import { PUBLIC_METAFY_ENV } from '$env/static/public';
import { dev } from '$app/environment';

export const COOKIE_POLICY_KEY = 'metafy-cookie-policy';
export const REDIRECT_STORE_KEY = 'metafy-redirect-store';
export const QUERY_PARAMS_KEY = 'metafy-query-params';
export const BOOKING_STATE_KEY = 'metafy-booking-state';

export const MEILISEARCH_API_HOST =
  PUBLIC_METAFY_ENV === 'development'
    ? 'https://search-dev.metafy.gg'
    : PUBLIC_METAFY_ENV === 'staging'
      ? 'https://search-staging.metafy.gg'
      : 'https://search.metafy.gg';
export const MEILISEARCH_API_KEY =
  PUBLIC_METAFY_ENV === 'development'
    ? 'c53c6737011ec09af9836256ec5e9fc0ffca2fedb5a00a9af5c0c83ae70023fb'
    : PUBLIC_METAFY_ENV === 'staging'
      ? '36430b8998ceffe234bf6677fe56775d2595b4081a23d09637be91ea1e9e517c'
      : 'bfcc8b495e43a379d721b7eb945bbea2960fd28bc9bda131d8015d5371483672';

export const STRIPE_PUBLISHABLE_KEY =
  PUBLIC_METAFY_ENV === 'development' || PUBLIC_METAFY_ENV === 'staging'
    ? 'pk_test_40DpPkZhqK69boNdC3ygyBgsCMGIzMq9rbRmeqBbD7ELUduU6gW4NcmKhvinbztWdiNVFfUfknl2OsCRDkFfVe7s7003wu2I6Mq'
    : 'pk_live_40DpPkZhqK69boNdC3ygyqOhhvwU83GPZTzPmQfuOe3LRwtHJaMYLH9ID5s7DvAi2bNpOASqoZSX1OfQhILfHb5Wu00aHgiDD2z';
export const STRIPE_ACCOUNT_ID = 'acct_1Gdi48JM3wLOMsbr';

export const PUSHER_CHANNEL_KEY =
  PUBLIC_METAFY_ENV === 'development'
    ? 'cfa11aac2216e647090b'
    : PUBLIC_METAFY_ENV === 'staging'
      ? '1899fc722f068945f727'
      : '00dabf2f34b055592034';

export const TENOR_API_KEY = dev ? 'GLKTSLSSCNBZ' : 'IJHDLI220DX8';
export const TENOR_API_KEY_V2 = dev
  ? 'AIzaSyAR_1oh-GFaJXj5_N6dqrlZdGhVfB4UHpA'
  : 'AIzaSyB5vWEcdPOkG1NhfVnBeVYgQ76s8YPnnH8';

export const MUX_DATA_KEY =
  PUBLIC_METAFY_ENV === 'development'
    ? 'd1bs7p2rs9ad392f5ojv25802'
    : PUBLIC_METAFY_ENV === 'staging'
      ? 'ei2cvk32sdd1pgdve1menit1l'
      : 'dm2rpf0hvjasc243fpuerb9ap';

export const RECURLY_KEY =
  PUBLIC_METAFY_ENV === 'production' ? 'ewr1-DKE9L3homxM5GFj2fcFPRm' : 'ewr1-W7FUQowl6VugdSdRaMVYlj';

export const STREAMIO_KEY =
  PUBLIC_METAFY_ENV === 'production'
    ? 'rwc8vchbdk2s'
    : PUBLIC_METAFY_ENV === 'staging'
      ? '4kbs6xhzcnj2'
      : '8jmjtuhy5atm';

export const STRIPE_PAYPAL_PM =
  PUBLIC_METAFY_ENV === 'production' ? 'cpmt_1RCqQDJM3wLOMsbra0soxogs' : 'cpmt_1RCqDPJM3wLOMsbrceqaZQZ1';
